const email = value => {
  value = value.replace(/\s/g, "");
  const regex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  const isValid = regex.test(value);
  return isValid ? undefined : 'Please enter a valid email';
};

export default email;